import React, { memo } from 'react';
import { formatCurrency } from '../helpers';

const ModuloPlanPagos = ({
    cuotasBorrador = [],
    cuotaInput,
    setCuotaInput,
    moneda = 'ARS',
    handleAddCuotaBorrador,
    handleRemoveCuotaBorrador,
    formatBlurInputAmount
}) => {
    const simboloMoneda = moneda === 'USD' ? 'U$S' : '$';
    const monedaSimbolo = moneda === 'USD' ? 'USD' : 'ARS';

    const totalBorrador = cuotasBorrador.reduce((acc, c) => acc + (parseFloat(c.monto) || 0), 0);

    return (
        <div className="p-4 bg-indigo-50/30 rounded-xl border border-indigo-200 space-y-4 animate-fade-in">
            <div className="flex justify-between items-center border-b border-indigo-200/80 pb-2">
                <span className="text-xs font-black text-indigo-950 uppercase tracking-wider flex items-center gap-1.5">
                    🏛️️ CARGAR CUOTAS AL PLAN DE PAGO
                </span>
                {cuotasBorrador.length > 0 && (
                    <span className="text-xs font-mono font-bold text-indigo-900 bg-indigo-100 px-2.5 py-1 rounded-md">
                        Subtotal Tanda ({cuotasBorrador.length}): {formatCurrency(totalBorrador, monedaSimbolo)}
                    </span>
                )}
            </div>

            <div className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3 items-end">
                    <div>
                        <label className="block text-[12px] font-bold text-indigo-900 mb-1 pl-1">F. Vencimiento Cuota *</label>
                        <input
                            type="date"
                            value={cuotaInput.fecha}
                            onChange={e => setCuotaInput(prev => ({ ...prev, fecha: e.target.value }))}
                            className="w-full border border-indigo-200 rounded-xl px-3 py-2 text-xs font-bold text-slate-800 outline-none bg-white h-[42px] focus:border-indigo-400"
                        />
                    </div>

                    <div>
                        <label className="block text-[12px] font-bold text-indigo-900 mb-1 pl-1">Monto Cuota ({simboloMoneda}) *</label>
                        <input
                            type="text"
                            value={cuotaInput.monto}
                            onChange={e => setCuotaInput(prev => ({ ...prev, monto: e.target.value }))}
                            onBlur={() => formatBlurInputAmount(cuotaInput.monto, (val) => setCuotaInput(prev => ({ ...prev, monto: val })))}
                            className="w-full border border-indigo-200 rounded-xl px-3 py-2 text-base font-mono font-bold text-slate-900 outline-none bg-white h-[42px] focus:border-indigo-400"
                            placeholder="0,00"
                        />
                    </div>

                    <button
                        type="button"
                        onClick={handleAddCuotaBorrador}
                        className="py-2.5 bg-indigo-700 hover:bg-indigo-800 text-white rounded-xl font-bold uppercase text-xs h-[42px] cursor-pointer transition-all shadow-xs active:scale-98"
                    >
                        + Cargar Cuota en la Tanda
                    </button>
                </div>

                {cuotasBorrador.length > 0 && (
                    <div className="space-y-2 pt-2 border-t border-indigo-200/80">
                        <span className="text-[10px] font-black text-indigo-900 uppercase tracking-wider block">
                            Cuotas listas para confirmar:
                        </span>
                        {cuotasBorrador.map((c, idx) => (
                            <div key={idx} className="flex items-center justify-between bg-white p-2.5 rounded-xl border border-indigo-200/80 text-xs font-semibold shadow-2xs">
                                <div className="flex items-center gap-3">
                                    <span className="font-extrabold text-indigo-950 uppercase">Cuota N° {c.numero}</span>
                                    <span className="text-slate-500">Vence: <strong className="text-slate-800 font-mono">{c.fechaVencimiento}</strong></span>
                                </div>
                                <div className="flex items-center gap-3">
                                    <span className="font-mono text-base font-black text-indigo-950">
                                        {formatCurrency(c.monto, monedaSimbolo)}
                                    </span>
                                    <button
                                        type="button"
                                        onClick={() => handleRemoveCuotaBorrador(idx)}
                                        className="text-rose-500 hover:text-rose-800 font-bold cursor-pointer ml-1 transition-colors p-1"
                                    >
                                        ✕
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default memo(ModuloPlanPagos);